var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoNtfc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.00003C12 7.18671 11.6481 8.34673 10.9888 9.33342C10.3295 10.3201 9.39247 11.0892 8.29611 11.5433C7.19976 11.9974 5.99336 12.1162 4.82947 11.8847C3.66558 11.6532 2.59648 11.0818 1.75736 10.2427C0.918247 9.40354 0.346802 8.33443 0.11529 7.17055C-0.116221 6.00666 0.00260139 4.80028 0.456727 3.70392C0.910853 2.60756 1.6799 1.6705 2.66659 1.01121C3.65329 0.351918 4.81332 2.47955e-05 6.00001 2.47955e-05C7.59131 2.47955e-05 9.11743 0.632143 10.2427 1.75736C11.3679 2.88258 12 4.40873 12 6.00003Z",
    fill: "#028DFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40037 6.00001C8.40223 6.15426 8.35144 6.30451 8.25638 6.42599C8.20509 6.49209 8.14893 6.55426 8.08838 6.61199L8.05238 6.64799C7.3423 7.3026 6.53206 7.8394 5.65238 8.238C5.47602 8.3209 5.28771 8.37558 5.09437 8.40001C4.95871 8.40045 4.82552 8.36379 4.70919 8.294C4.59286 8.2242 4.49784 8.1239 4.43438 8.00399C4.37375 7.83169 4.32561 7.65522 4.29037 7.47599C4.22436 6.98685 4.19428 6.49355 4.20037 6.00001C4.19231 5.49007 4.22644 4.98031 4.30238 4.47599C4.32989 4.33197 4.36595 4.18974 4.41038 4.05001C4.47634 3.89604 4.5927 3.76906 4.74037 3.68999C4.85753 3.63065 4.98705 3.59983 5.11837 3.60001C5.28937 3.62557 5.4566 3.67191 5.61637 3.738C6.50746 4.14003 7.32799 4.68298 8.04638 5.346L8.24437 5.55001C8.34591 5.67797 8.40093 5.83666 8.40037 6.00001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoNtfc);
export default __webpack_public_path__ + "static/media/videoNtfc.41c13eb55d166ebb240b9ce5fb0a7fb0.svg";
export { ForwardRef as ReactComponent };